export default __webpack_public_path__ + "fonts/edu_1.1750165f21e02e2856dc7d96d0529f32.png";